<template>
    <div id="app">
        <el-container v-if="!isAdminRoute">
            <!-- height 是 el-header 的 prop（默认 60px），以行内样式下发，CSS 覆盖不了；
                 手机端需改为 auto 才能让展开的菜单撑开头部而不是叠在正文上 -->
            <el-header :height="isMobile ? 'auto' : '60px'">
                <div class="logo">
                    <img :src="getImagePath('toplogo.png')" alt/>
                </div>
                <button
                    class="nav-toggle"
                    type="button"
                    aria-label="菜单"
                    :aria-expanded="mobileMenuOpen ? 'true' : 'false'"
                    @click="mobileMenuOpen = !mobileMenuOpen"
                >
                    <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
                </button>
                <el-menu
                    :key="isMobile ? 'menu-vertical' : 'menu-horizontal'"
                    :default-active="defaultActive"
                    class="el-menu-demo"
                    :class="{'mobile-open': mobileMenuOpen}"
                    :mode="isMobile ? 'vertical' : 'horizontal'"
                    @select="handleSelect"
                    :router="router"
                >
                    <el-menu-item index="/">{{ $t('menu.home') }}</el-menu-item>
                    <el-menu-item index="/news">{{ $t('menu.news') }}</el-menu-item>
                    <el-menu-item index="/cpzx">{{ $t('menu.product') }}</el-menu-item>
                    <!--          <el-menu-item index="/product">产品中心</el-menu-item>-->
                    <el-menu-item index="/jjfa">{{ $t('menu.solution') }}</el-menu-item>
                    <el-menu-item index="/case">{{ $t('menu.cases') }}</el-menu-item>
                    <el-menu-item index="/goin">{{ $t('menu.about') }}</el-menu-item>
                    <el-menu-item index="/shfw">{{ $t('menu.service') }}</el-menu-item>
                    <el-menu-item index="/download">{{ $t('menu.download') }}</el-menu-item>
                </el-menu>
                <div class="lang-switch">
                    <el-button
                        size="small"
                        :type="$i18n.locale === 'zh' ? 'primary' : ''"
                        @click="switchLang('zh')"
                    >
                        中文
                    </el-button>
                    <el-button
                        size="small"
                        :type="$i18n.locale === 'en' ? 'primary' : ''"
                        @click="switchLang('en')"
                    >
                        EN
                    </el-button>
                </div>
            </el-header>
            <el-main>
                <router-view/>
            </el-main>
            <div class="footer">
                <div class="footer-content">
                    <ul class="content-nav">
                        <li>
                            <p>{{ $t('footer.news') }}</p>
                            <span>{{ $t('footer.companyNews') }}</span>
                            <span>{{ $t('footer.industryNews') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.products') }}</p>
                            <span>{{ $t('footer.recorder') }}</span>
                            <span>{{ $t('footer.workstation') }}</span>
                            <span>{{ $t('footer.system') }}</span>
                            <span>{{ $t('footer.cabinet') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.solutions') }}</p>
                            <span>{{ $t('footer.industrySolution') }}</span>
                            <span>{{ $t('footer.cabinetSolution') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.about') }}</p>
                            <span>{{ $t('footer.history') }}</span>
                            <span>{{ $t('footer.culture') }}</span>
                            <span>{{ $t('footer.honors') }}</span>
                            <span>{{ $t('footer.partners') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.service') }}</p>
                            <span>{{ $t('footer.afterSales') }}</span>
                            <span>{{ $t('footer.policy') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.contact') }}</p>
                            <span>{{ $t('footer.email') }}</span>
                            <span>{{ $t('footer.phone') }}</span>
                            <span>{{ $t('footer.address') }}</span>
                        </li>
                    </ul>
                    <img :src="getImagePath('ercode.jpg')" alt/>
                </div>
                <div class="copyright">
                    <span>{{ $t('footer.copyright') }}</span>
                </div>
            </div>
        </el-container>
        <router-view v-else/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            router: true,
            defaultActive: "/",
            isShow: false,
            mobileMenuOpen: false,
            windowWidth: window.innerWidth
        };
    },
    computed: {
        isAdminRoute() {
            return this.$route.path.startsWith('/admin');
        },
        isMobile() {
            return this.windowWidth <= 768;
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleSelect(key) {
            this.isShow = this.defaultActive != key;
            this.mobileMenuOpen = false;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            if (!this.isMobile) {
                this.mobileMenuOpen = false;
            }
        },
        switchLang(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem('lang', lang);
            window.location.reload();
        }
    }
};
</script>



<style lang="scss">
* {
    padding: 0;
    margin: 0;
}

html,
body {
    height: 100%;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.el-header {
    //position: fixed;
    //z-index: 1024;
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 1240px;
    margin: 0 auto;
    //background-color: #fff;

    .logo {
        width: 280px;
        padding: 10px;

        img {
            width: 100%;
            line-height: 60px;
        }
    }

    .lang-switch {
        display: flex;
        align-items: center;
        gap: 5px;
    }
}

.el-main {
    padding: 0 !important;
    //margin-top: 60px;
}

.footer {
    width: 100%;
    height: 235px;
    overflow: hidden;
    background-color: #14679f;

    &-content {
        width: 1340px;
        margin: 0 auto;
        padding-top: 20px;
        display: flex;
        justify-content: space-between;

        .content-nav {
            display: flex;
            justify-content: space-around;

            li {
                display: flex;
                flex-direction: column;
                padding: 0 20px;
                //justify-content: center;
                align-items: flex-start;

                p {
                    font-size: 20px;
                    color: #d4edff;
                    padding: 10px 0;
                }

                span {
                    color: #f7f7f7;
                    font-weight: 300;
                    padding: 5px 0;
                }
            }
        }

        img {
            width: 170px;
            height: 170px;
            padding: 10px;
        }
    }

    .copyright {
        //height: 30px;
        //background: #125688;
        font-size: 0.75em;
        color: #e1e1e1;
        line-height: 1.5;
        text-align: center;

        span {
            color: #fff;
            //line-height: 30px;
            padding-bottom: 5px;
        }
    }
}

.nav-toggle {
    display: none;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background: transparent;
    color: #14679f;
    font-size: 24px;
    cursor: pointer;
}

// 窄屏 / 平板：定宽容器改流式
@media (max-width: 1280px) {
    .el-header {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .footer-content {
        width: 100%;
        padding: 20px 20px 0;
        box-sizing: border-box;
    }
}

// 手机
@media (max-width: 768px) {
    // 加 #app 提升一级优先级：element-ui 的 .el-header{padding:0 20px} 在本文件之后加载，
    // 同级选择器会被它盖掉，0 12px 就白写了
    #app .el-header {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        flex-wrap: wrap;
        justify-content: flex-start;

        .logo {
            width: 150px;
            padding: 6px 0;
        }

        .lang-switch {
            order: 1;
            margin-left: auto;
        }
    }

    // order 保证「语言切换 + 汉堡」占据首行右侧，菜单展开时整行落到第二行
    .nav-toggle {
        display: flex;
        flex-shrink: 0;
        order: 2;
        margin-left: 8px;
    }

    .el-menu-demo {
        order: 3;
        display: none;
        width: 100%;
        border-right: none;
        border-top: 1px solid #e6e6e6;

        &.mobile-open {
            display: block;
        }
    }

    .footer {
        height: auto;

        &-content {
            flex-direction: column;
            align-items: center;
            padding: 20px 12px 0;

            .content-nav {
                width: 100%;
                flex-wrap: wrap;
                justify-content: flex-start;

                li {
                    width: 50%;
                    padding: 6px 0;
                    box-sizing: border-box;

                    p {
                        font-size: 16px;
                        padding: 6px 0;
                    }

                    span {
                        font-size: 13px;
                    }
                }
            }

            img {
                width: 120px;
                height: 120px;
                margin-top: 10px;
            }
        }

        .copyright {
            padding: 10px 12px 0;
        }
    }
}
</style>
